import styled from 'styled-components';
import media from 'src/styles/Media.styled';
import Grid from '@material-ui/core/Grid';

export const StyledImage = styled.img`
    display: flex;
    align-items: center;
    object-fit: contain;
    cursor: pointer;
`;

export const AccountListContainer = styled.div`
    position: relative;
    /* background: #f5f5f5; */
    height: calc(100vh - 23rem);
    overflow-x: hidden;
    display: flex;
    flex-direction: column;
    flex-grow: 1;
    border-radius: 6px;
    padding: 0 2px;
    padding-bottom: 60px;
    overflow-y: scroll;
    &::-webkit-scrollbar {
        display: ${({ theme }) => theme.scrollOption.show};
        width: 5px;
    }
    &::-webkit-scrollbar-track {
        margin-top: 0px;
    }
    &::-webkit-scrollbar-thumb {
        background-color: ${({ theme }) => theme.scrollOption.thumb_color};
        border-radius: ${({ theme }) => theme.scrollOption.border_radius};
    }
    @media screen and (min-device-width: 1100px) and (max-device-width: 1120px) and (min-device-height: 825px) and (max-device-height: 840px) and (orientation: landscape){
        padding-bottom: 200px;
   }
   @media screen and (min-device-width: 1360px) and (max-device-width: 1370px) and (min-device-height: 1020px) and (max-device-height: 1130px) and (orientation: landscape) {
    padding-bottom: 200px;
    }
    @media screen and (min-device-width: 1020px) and (max-device-width: 1030px) and (min-device-height: 1350px) and (max-device-height: 1370px) {
        height: calc(100vh);
    }

    ${media.mediumDevice`
    
        &::-webkit-scrollbar {
            display:  none;  
        }
    `}
    ${media.smalDevice`
        flex-direction: column;   
       
        &::-webkit-scrollbar {
            display:  none; }`}
    
    
   

    ${media.mobileDevice`
        display: block;
        border-top-left-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        border-top-right-radius: ${(props) =>
            props.filterDataOpen | props.accountSearchOpen ? 0 : '20px'};
        box-shadow:none;
        border-bottom-left-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        border-bottom-right-radius: ${(props) =>
            props.filterCount ? 0 : '0px'};
        height: calc(100vh - 250px);
        overflow-y: scroll;
        padding-bottom: 280px;
        &::-webkit-scrollbar {
            display:  none;  
        }`}
`;

export const ButtonLabel1 = styled(Grid)`
    display: flex;
    height: 27px;
    text-align: left;
    font-family: 'AvenirNextWorld Demi';
    font-size: 16px;
    color: #1010eb;
    cursor: pointer;
    margin: 0 0 0 4px;
`;

export const PopupContainer = styled.div`
    display: block;
    width: 100%;
    height: 100%;
    overflow: hidden;
`;
export const BodyTextContainer = styled(Grid)`
    padding-top: 10px;
    font-family: 'AvenirNextWorld Regular';
    text-align: left;
    font-size: 15px;
    color: #202124;
    ${media.mediumDevice`
    padding-left: 11px;
`}
    ${media.mobileDevice`
    margin-left: 0;
    padding-left: 20px;
    `}
`;

export const Container2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display:block;
    // margin-left: 19px;
    width:100%;
    `}
`;

export const DistrictGrid = styled(Grid)`
    ${media.mobileDevice`
   display: none;
    `}
`;

export const DistrictHeading = styled(Grid)`
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
`;

export const DistrictName = styled(Grid)`
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
`;

export const TerritoryGrid = styled(Grid)`
    ${media.mobileDevice`
   display: none;
    `}
`;

export const TerritoryGridMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    // margin-left: 5% !important;
    margin-top: 20px !important;
    `}
`;

export const DistrictGridMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    // margin-left: 5% !important;
    margin-top: 20px !important;
    `}
`;

export const TerritoryHeading = styled(Grid)`
    font-size: 14px;
    font-family: 'AvenirNextWorld Demi';
`;

export const TerritoryName = styled(Grid)`
    font-size: 15px;
    font-family: 'AvenirNextWorld Regular';
    color: #202124;
    width: ${({isMobile}) => isMobile ? 'max-content' : '200px'};
    overflow-wrap: ${({isMobile}) => isMobile ? 'normal' : 'break-word'};
`;

export const BodyGridContainer = styled(Grid)`
    background: #ffffff;
    box-shadow: 0px 0px 6px #00000029;
    border: 1px solid #ececec;
    border-radius: 6px 6px 6px 6px;
    padding: 15px 0;
    margin-top: 10px;
    ${media.mediumDevice`
        // margin-bottom: 150px;
    `}
    ${media.mobileDevice`
    width: 94% !important;
    // margin-left: 10px;
    margin: 10px auto;
    padding: 15px;
    `}
`;

export const Name = styled(Grid)`
    padding-left: 19px;
    ${media.mobileDevice`
    padding-left: 0;
    `}
`;

export const User1 = styled(Grid)`
    color: #140f4b;
    font-size: 16px;
    font-family: 'AvenirNextWorld Demi';
`;

export const Designation1 = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`

    `}
`;

export const Designation3 = styled(Grid)`
    color: #3c3c3c;
    opacity: 0.61;
    font-size: 12px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
    display: none;
    `}
`;

export const Designation2 = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: #202124;
    opacity: 0.7;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    margin: 2px 0 0 10px;
    `}
`;

export const ValidDate = styled(Grid)`
    color: #3c3c3c;
    font-size: 15px;
    padding-left: 6px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
   display: none;
    `}
`;

export const Line = styled(Grid)`
    margin: 17px 0px 17px 35px;
    width: 693px;
    background-color: #707070;
    border: 0.6px solid #707070;
    opacity: 0.3;
    ${media.mobileDevice`
    width: 100%;
    margin : 20px auto;
    `}
`;

export const Date = styled(Grid)`
    color: #202124;
    opacity: 0.7;
    font-size: 14px;
    font-family: 'AvenirNextWorld Regular';
    ${media.mobileDevice`
    margin: 2px 0 0 5px;
    `}
`;

export const LineMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    display: block;
    color: #202124;
    opacity: 0.7;
    padding-left: 5px;
    `}
`;

export const UserName = styled(Grid)`
    color: #202124;
    font-size: 16px;
    font-family: 'AvenirNextWorld Regular';
`;

export const Created = styled(Grid)`
    ${media.mobileDevice`
    display: flex;
    // margin-left: 18px !important;
    `}
`;

export const CreatedByMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
    // margin-top: 20% !important;
    // margin-left: -39% !important;
    display: block;
    // padding-left: 20px;
    font-family: 'AvenirNextWorld Demi'; 
    font-size: 14px;
    color: #202124;
    margin-top: 20px;
    `}
`;

export const ValidDateMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`

display: block;
font-family: 'AvenirNextWorld Regular'; 
font-size: 16px;
color: #202124;
    `}
`;

export const ValidDateHeadingMob = styled(Grid)`
    display: none;
    ${media.mobileDevice`
margin-top: 20px;
display: block;
font-family: 'AvenirNextWorld Demi'; 
font-size: 14px;
color: #202124;
    `}
`;

export const HeaderTextContainer = styled(Grid)`
    color: #3c3c3c;
    font-size: 13px;
    font-family: 'AvenirNextWorld Demi';
    ${media.mobileDevice`
    display: none !important;
    `}
`;

export const HeaderGridContainer = styled(Grid)`
   
    // padding: ${({ padding }) => (padding ? padding : '10px 0 10px 10px')};
    background: #ffffff;
    box-shadow: 0px 1px 2px #00000029;
    border: 1px solid #ececec;
    border-radius: 6px 6px 0px 0px;
    align-items: center;
    padding: 12px 16px;
    position: sticky;
    z-index: 1;
    top: 0px;
    ${media.smalDevice`
        display: none !important;
    `}
`;
export const EditIconContainer = styled(Grid)`
    width: 81px;
    height: 36px;
    background: #ffffff;
    box-shadow: 0px 0px 2px #00000029;
    border: 1px solid #ebebeb;
    border-radius: 25px;
    opacity: 1;
    margin-bottom: 20px;
    ${media.mobileDevice`
    `}
`;

export const EditContainerMain = styled(Grid)`
    margin-left: 20px;
    ${media.mobileDevice`
    // padding-left: 68%;
    // margin-top: -48%;
    margin-left: 0;
    position: absolute;
    right: 10%;
    `}
`;

export const EditContainer = styled(Grid)`
    color: #1010eb;
    padding: 4px 0 0 7px;
    font-family: 'AvenirNextWorld Demi';
    font-size: 14px;
    opacity: 1;
    /* ${media.smalDevice`
    padding-left: 7px;
    `}
    ${media.mediumDevice`
    padding-left: 7px;
    `} */
    ${media.mobileDevice`
    
    `}
`;
